(ns nosco.ui.base
  "A collection of very very basic components that are needed even in main."
  (:require
   ["react" :as React]
   ["react-useportal" :default usePortal]
   [hx.hooks :as hooks]
   [hx.react :refer [defnc]]
   [nosco.i18n.translate :as t]
   [nosco.polyfills]
   [nosco.router :as router]
   [nosco.ui.empty-states :as empty-states]
   [nosco.ui.errors :as errors]
   [nosco.ui.layouts :as layouts]
   [nosco.util :as util]))


(defnc NewStackingContext [{:keys [children]}]
  ;; https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
  [:div {:style (if (nosco.polyfills/IE11?)
                  {:position "relative"
                   :z-index 0}
                  {:isolation "isolate"})}
   children])

;; Modals have an issue with the rendering order of react
;; if you let the default behaviour of justing appending to document.body
;; then you're bound to end up with a situation where the Portal <divs>
;; end up out of order (eg. if you remove the parent of a Portal from the DOM),
;; and add it again, then it will end up at the bottom of the body, therefore
;; above everything else... there's more scenarios like this.

;; therefore what we do is we try to align the React tree with the portals order.
;; We create a hierarchy of ContextProviders so that the deeper you go, the more
;; to the end of the document.body you end up. I'm not 100% sure this is the correct
;; heuristic, but given that our scenarios so far only involve a single modal this
;; seems to be working

;; Snags: we rely on the same z-index for all, so we can't use a z-index 2
;; in the modals3 approach.

(defonce ModalManagerContext (React/createContext nil))

(defn use-create-modal-root [previous-dom]
  (let [root-ref (React/useRef)]
    (hooks/useLayoutEffect
     (fn []
       (let [div (.createElement js/document "div")]
         (if previous-dom
           (.insertBefore js/document.body div (.-nextSibling previous-dom))
           (.appendChild js/document.body div))
         (.setAttribute div "class" (util/genid "modal-manager"))
         (set! (.-current root-ref) div)
         (fn []
           (.removeChild js/document.body div))))
     [])

    root-ref))

(defnc ModalManager [{:keys [children]}]
  (let [previous-dom (hooks/useContext ModalManagerContext)
        root-ref (use-create-modal-root (when previous-dom (.-current previous-dom)))]
    [:provider {:context ModalManagerContext
                :value root-ref}
     children]))

(defnc ModalPortal [{:keys [children]}]
  (let [dom-ref (hooks/useContext ModalManagerContext)
        Portal (.-Portal (usePortal #js {:bindTo (.-current dom-ref)}))]
    [Portal
     [ModalManager
      children]]))


(defonce base-site-title (atom "Nosco"))
(defn set-base-site-title! [base-title]
  (reset! base-site-title base-title)
  (set! (.-title js/document) base-title))

(defn use-set-title [title]
  (hooks/useEffect
   (fn []
     (when title
       (let [prev-title (.-title js/document)]
         (set! (.-title js/document) (str title " | " @base-site-title))
         #(set! (.-title js/document) prev-title))))
   [title]))
